import { resolveRawDirectionsPayload } from "@utils/mode_tool/rawDirectionsRoute";

export function extractRouteGeometry(routeItem = {}) {
  const raw = resolveRawDirectionsPayload(routeItem?.directiosApiRoutePointRaw);
  const normalizedRoutes =
    raw?.routes && typeof raw.routes === "object" && !Array.isArray(raw.routes)
      ? Object.entries(raw.routes).filter(([, routeItem]) =>
          Array.isArray(routeItem?.geometry?.coordinates),
        )
      : [];
  const groupedCoordinates = Array.isArray(raw?.groups)
    ? raw.groups
        .map((group) => group?.geometry?.coordinates)
        .filter((coordinates) => Array.isArray(coordinates))
    : [];
  const geometry =
    (normalizedRoutes.length > 1
      ? {
          type: "MultiLineString",
          coordinates: normalizedRoutes.map(
            ([, routeValue]) => routeValue.geometry.coordinates,
          ),
        }
      : normalizedRoutes.length === 1
        ? normalizedRoutes[0][1]?.geometry || null
        : null) ||
    raw?.routes?.main?.geometry ||
    raw?.geometry ||
    (groupedCoordinates.length > 1
      ? { type: "MultiLineString", coordinates: groupedCoordinates }
      : groupedCoordinates.length === 1
        ? { type: "LineString", coordinates: groupedCoordinates[0] }
        : null) ||
    raw?.routes?.[0]?.geometry ||
    routeItem?.geometry ||
    null;
  if (!geometry?.type || !Array.isArray(geometry?.coordinates)) return null;
  return geometry;
}
